export const languageMappings = {
  География: 'Географія',
  Геометрия: 'Геометрія',
  'История Украины': 'Історія України',
  'Украинский язык': 'Українська мова',
  'Английский язык': 'Англiйська мова',
  Физика: 'Фізика',
  Биология: 'Біологія',
  Природа: 'Природа',
  'Младшая школа - Математика': 'Молодша школа - Математика',
  'Всемирная история': 'Всесвітня історія',
  Химия: 'Хімія',
  'Младшая школа - Русский язык': 'Молодша школа - Російська мова',
  'Украинская литература': 'Українська література',
  'Зарубежная литература': 'Зарубіжна література',
  'Младшая школа - Украинский язык': 'Молодша школа - Українська мова',
};

export const gradeMappings = {
  '1 класс': '1 клас',
  '2 класс': '2 клас',
  '3 класс': '3 клас',
  '4 класс': '4 клас',
  '5 класс': '5 клас',
  '6 класс': '6 клас',
  '7 класс': '7 клас',
  '8 класс': '8 клас',
  '9 класс': '9 клас',
  '10 класс': '10 клас',
  '11 класс': '11 клас',
  ЗНО: 'ВНО',
  'ВНО углублённый уровень': 'ЗНО поглиблений рівень',
};
